module.exports = __webpack_public_path__ + "02_very_short_brown.30055fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_very_short_brown.png
// module id = Bca0
// module chunks = 0